import { addCommas } from "@persian-tools/persian-tools";
import ColorSchema from "../../../assets/kits/colors";

export default function VendorOrdersItem({ status, onClickFunc }) {
  return (
    <div
      className="pd-x-12 mr-b-16"
      onClick={() => onClickFunc()}
      style={{
        border: `1px solid #D1D5DB`,
        borderRadius: 6,
        cursor: "pointer",
      }}
    >
      <div className="mr-y-12 txt-t3-m" style={{ color: ColorSchema.gray_900 }}>
        <div
          className="d-flex justify-content-between mr-b-8 "
          style={{ height: 18 }}
        >
          <div>
            نام فاکتور: <span className="mr-r-6">12233</span>
          </div>
          <div>10:02</div>
        </div>
        <div style={{ height: 18 }}>
          قیمت کل سفارش:{" "}
          <span className="mr-r-6">{addCommas(124545)}تومان</span>
        </div>
      </div>
      <div
        className="d-flex "
        style={{ width: "auto", border: `1px solid #D1D5DB` }}
      ></div>
      <div className="mr-y-12  ">
        <div className="d-flex">
          <div
            className="pd-x-6 desc-m  d-flex align-items-center "
            style={{
              borderRadius: 4,
              height: 23,
              backgroundColor:
                status == 0
                  ? ColorSchema.yellow_700
                  : status == 1
                  ? ColorSchema.red_600
                  : status == 2 && ColorSchema.green_700,
              color: ColorSchema.white_0,
            }}
          >
            {status == 0
              ? "در حال آماده سازی"
              : status == 1
              ? "بررسی نشده"
              : status == 2 && "تحویل شده"}
          </div>
        </div>

        <div className="mr-t-8 desc-m" style={{ color: ColorSchema.gray_600 }}>
          چیپس نمکی 120گرمی، پفک چی توز و 3 کالای دیگر
        </div>
      </div>
    </div>
  );
}
